import { Breadcrumb, HeaderTitle, LinkText } from '@/components/atoms'
import { PageHeader } from '@/components/molecules'
import CustomDataTable from '@/components/organisms/CustomDataTable/CustomDataTable.jsx'
import { usePointMultiplier } from '@/hooks/usePointMultiplier'
import { ROUTES } from '@/utils/constants/routesConstants'
import { Header } from '@/utils/constants/header'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { getCellDataMappedCols } from '@/helpers/dataTableCellDataMapper'
import { resetPointMultiplier } from '@/store/slices/pointMultiplier'
import { useAppDispatch } from '@/store'
import './PointMultiplier/_pointMultiplier.scss'
import { getSelectedRowData } from '@/utils/commons'

const cellDataMapperObj = navigate => ({
  multiplierName: {
    cellData: ({ row: { original } = {} }) => (
      <LinkText
        text={original?.multiplierName}
        id={original?.multiplierName + ' ' + (original?.id || original?.uuid)}
        handleClick={() => navigate(`${ROUTES.POINT_MULTIPLIER_VIEW.replace(':id', original?.id || original?.uuid)}`, {
          state: { id: original?.id, uuid: original?.uuid, formData: getSelectedRowData(original)},
        })}
      />
    ),
    linkHandler: (row) => navigate(`${ROUTES.POINT_MULTIPLIER_VIEW.replace(':id', row?.id || row?.uuid)}`, {
      state: { id: row?.id, uuid: row?.uuid, formData: getSelectedRowData(row) },
    }),
    linkLabel: (row) => row.multiplierName || '—',
  }
})

export const PointMultiplier = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [rowSelected, setRowSelected] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const {
    pointMultiplierData,
    pointMultiplierColConfigData,
    pageIndex,
    setPageIndex,
    setSortingObj,
    setSearchArry,
    isLoading,
    onDownloadBtnClick,
    handleResetAll: hookResetAll,
    sortingObj
  } = usePointMultiplier();
  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj(navigate), pointMultiplierColConfigData);
  const handleResetFormData = () => {
    dispatch(resetPointMultiplier());
    navigate(ROUTES.POINT_MULTIPLIER_CREATE);
  };
  const handleResetAll = () => {
    setRowSelected([]);
    setIsSelectAll(false);
    hookResetAll();
  };
  const onDownloadClick = (selectedRows) => {
    // selectedRows is empty array when select all is active (passed from CustomDataTable)
    // Otherwise it contains the selected row objects
    const ids = selectedRows?.length > 0 
      ? selectedRows.map(item => item?.id || item?.uuid)
      : [];
    onDownloadBtnClick(ids);
  };
  return (
    <div className="pointMultiplierContent flex flex-col">
      <Breadcrumb
        uiSchema={{
          isDark: true,
          className: 'mb-5',
          breadcrumbs: [
            {
              href: '/',
              label: '',
            },

            {
              href: '',
              label: 'Point Multipliers',
            },
          ],
        }}
        id={'pm_bradcrumb'}
      />
      <PageHeader title="Point Multiplier" />
      <div className="relative" style={{ backgroundColor: '#1D1D1D' }}>
        <HeaderTitle
          headingLevel={Header.SectionTitle}
          title="Point Multiplier List"
          className="PointMultiplierDataTableHeading  pl-4 pr-4"
        />
        <div className="pointMultiplierDataTable pointMultiplierCustomToolbar">
          <CustomDataTable
            columns={cellDataMappedCols}
            records={pointMultiplierData?.data || []}
            isLoading={isLoading}
            pageSize={10}
            totalRecords={pointMultiplierData?.totalRecords || 0}
            setPageIndex={setPageIndex}
            handleSorting={setSortingObj}
            setSearchArry={setSearchArry}
            onResetAll={handleResetAll}
            onRowSelect={(selectedRecords, isAll) => {
              setRowSelected(selectedRecords);
              setIsSelectAll(isAll);
            }}
            isSelectAll={isSelectAll}
            onDownload={onDownloadClick}
            showDownload={true}
            onNameClick={getSelectedRowData}
            pageIndex={pageIndex}
            showCreateNew={true}
            onCreateNew={handleResetFormData}
            initialSortConfig={sortingObj}
          />
          {pointMultiplierData?.totalRecords > 0 && (
            <div className="txtRightAlign">{pointMultiplierData?.totalRecords} total items</div>
          )}
        </div>
      </div>
    </div>
  )
}
